import { type EmptyStateSize } from '@getgo/chameleon-core'
import { ShellElement } from '../../../common/shell-element'
import searchError from './search-error.styles.scss'
import { html, property } from 'lit-element'
import { PICTOGRAM_ALERT_STATIC } from '@getgo/chameleon-pictograms'
import { t } from '../../../directives/translate'

export interface searchErrorProps {
  readonly size: EmptyStateSize
}

export class SearchError extends ShellElement implements searchErrorProps {
  static readonly tagName = 'goto-search-error'

  @property({ type: String }) size: EmptyStateSize = 'medium'

  static get styles() {
    return searchError
  }

  render() {
    return html`
      <chameleon-listbox
        ><chameleon-listbox-item>
          <chameleon-empty-state size="small">
            <chameleon-svg slot="icon" class="error-pictogram">${PICTOGRAM_ALERT_STATIC}</chameleon-svg>
            ${t('Something went wrong. Go ahead and try your search again.')}<br />
            ${t('If the problem persists, contact')}
            <chameleon-link href="https://support.goto.com/products">${t('Support')}</chameleon-link>
          </chameleon-empty-state>
        </chameleon-listbox-item>
      </chameleon-listbox>
    `
  }
}

declare global {
  interface HTMLElementTagNameMap {
    readonly [SearchError.tagName]: SearchError
  }
}
